import React, { useEffect, useRef, useState } from 'react';

import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';

import { loginAction } from '../../redux/Slice/userAuth';
import {
  useIsLoggedInQuery,
  useLoginMutation,
  useOtpVerifyMutation
} from '../../redux/apis/authApi';

import GoogleImg from '../../assets/images/verify.svg';

import { otpSchema } from '../../utils/schemas/auth';
import { GLOBAL } from '../../utils/constant/global';
import { TOST_MESSAGE, TOAST_TYPE } from '../../utils/constant/errorMessage';
import { notification } from '../../utils/notification';
import { getAuthErrorMessage } from '../../utils/handler';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';

const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { BACKSPACE } = GLOBAL;
const { VERIFICATION, VERIFY, RECEIVED, RESEND } = GLOBAL;
const { BTN_PLEASE_WAIT } = BT_BUTTON_LABELS;
const { LOADING } = GLOBAL;

function StepAuthentication() {
  const dispatch = useDispatch();
  const [userVerify] = useOtpVerifyMutation();
  const { refetch } = useIsLoggedInQuery();
  const [loading, setLoading] = useState(false);
  const [userLogin] = useLoginMutation();
  const location = useLocation();

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(otpSchema)
  });

  const handleReSendOtp = async () => {
    try {
      const data = {
        email: location?.state?.email
      };
      if (data) {
        const res = await userLogin(data);
        if (res?.data?.success) {
          notification(res?.data?.statusMessage, TOAST_SUCCESS);
        } else {
          notification(getAuthErrorMessage(res), TOAST_ERROR);
        }
      }
    } catch (error) {
      notification(error?.message, TOAST_ERROR);
    }
  };
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      if (!location?.state?.email) {
        notification(TOST_MESSAGE?.EMAIL_NOT_VALID, TOAST_ERROR);
        return;
      }

      const { OTP1, OTP2, OTP3, OTP4, OTP5, OTP6 } = data;
      const OTP = `${OTP1}${OTP2}${OTP3}${OTP4}${OTP5}${OTP6}`;

      const res = await userVerify({
        emailMobile: location?.state?.email,
        otp: OTP
      });

      if (res?.data?.success) {
        setTimeout(async () => {
          await refetch();
        }, 100);
        dispatch(loginAction(res?.data?.data));
        setLoading(false);
      } else {
        notification(getAuthErrorMessage(res), TOAST_ERROR);
        setLoading(false);
      }
    } catch (error) {
      notification(error?.message, TOAST_ERROR);
      setLoading(false);
    }
  };

  const otp = ['OTP1', 'OTP2', 'OTP3', 'OTP4', 'OTP5', 'OTP6'];
  const inputRefs = useRef([]);

  useEffect(() => {
    inputRefs.current[0].focus();
  }, []);

  const handleInputChange = (e, index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setValue(e.target.name, value);

    if (index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    const inputValue = e.target.value;
    if (inputValue.length >= 1 && e.key !== BACKSPACE) {
      e.preventDefault(); // Prevent entering more than one digit
      handleInputChange(e, index, e.target.value);
    } else if (e.key === BACKSPACE && index > 0 && inputValue.length === 0) {
      inputRefs.current[index - 1].focus(); // Move focus to the previous input on Backspace
    }
  };

  return (
    <div className="col-lg-6 d-flex justify-content-center align-items-center border-0 rounded-lg auth-h100">
      <div
        className="w-100 p-3 p-md-5 card border-0 bg-dark text-light"
        style={{ maxWidth: '32rem' }}
      >
        <form className="row g-1 p-3 p-md-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="col-12 text-center mb-1 mb-lg-5">
            <img src={GoogleImg} className="w240 mb-4" alt="" />
            <h1>{VERIFICATION}</h1>
            <span>
              We sent a verification code to your email. Enter the code from the email in the field
              below.
            </span>
          </div>
          {otp.length > 0
            ? otp?.map((digit, index) => (
                <div className="col" key={index}>
                  <div className="mb-2">
                    <input
                      type="text"
                      pattern="\d"
                      maxLength={1}
                      name={digit}
                      className="form-control form-control-lg text-center"
                      {...register(digit)}
                      onKeyUp={(e) => {
                        handleKeyDown(e, index);
                      }}
                      ref={(ref) => (inputRefs.current[index] = ref)}
                    />
                  </div>
                </div>
              ))
            : null}

          <p>
            {Object.keys(errors).filter((key) => key.startsWith('OTP') && errors[key]).length >
            0 ? (
              <small className="text-danger">{TOST_MESSAGE.OTP_VALIDATION}</small>
            ) : null}
          </p>
          <div className="col-12 text-center mt-4">
            <button type="submit" className="btn btn-lg btn-block btn-light lift text-uppercase">
              {loading && (
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">{LOADING}</span>
                </div>
              )}
              {loading ? BTN_PLEASE_WAIT : VERIFY}
            </button>
          </div>
          <div className="col-12 text-center mt-4">
            <span className="text-muted">
              {RECEIVED}
              &nbsp;
              <span
                className="text-secondary cursor-pointer"
                onClick={() => {
                  handleReSendOtp();
                }}
              >
                {RESEND}
              </span>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StepAuthentication;
